import styled from "styled-components";

import images from "images";

import * as Types from "Types";

const LogoWrap = styled.a<Types.Default>`
   ${({ css }) => css}
`;

const LogoImage = styled.img`
   max-height: 25px;
`;

function Logo(props: Types.Default) {
   return (
      <LogoWrap {...props} href="/">
         <LogoImage src={images.logo3x} alt="" />
      </LogoWrap>
   );
}

export default Logo;
